import { useState, useEffect } from 'react';

export const useScrollIndicators = () => {
  const [showScrollFade, setShowScrollFade] = useState(true);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      
      // Calculate scroll progress percentage
      const maxScroll = scrollHeight - clientHeight;
      const progress = maxScroll > 0 ? (scrollTop / maxScroll) * 100 : 0;
      setScrollProgress(progress);
      
      // Hide fade when near bottom (within 100px)
      if (scrollHeight - scrollTop - clientHeight < 100) {
        setShowScrollFade(false);
      } else {
        setShowScrollFade(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { showScrollFade, scrollProgress };
};
